import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../../../../../app/core/services/auth.service';
import { GlobalName } from '../../../../../../app/core/utils/global-name';
import { LocalStorageService } from '../../../../../../app/core/utils/local-stoarge-service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxPaginationModule } from 'ngx-pagination';
import { SampleSearchPipe } from '../../../../../core/pipes/sample-search.pipe';
import { LoadingComponent } from '../../../../shared/loading/loading.component';
import { UserService } from '../../../../../core/services/user.service';
import { AppErrorShow } from '../../../../../core/utils/app-error-show';
import { NgSelectModule } from '@ng-select/ng-select';

@Component({
  selector: 'app-user-profil',
  templateUrl: './user-profil.component.html',
  styleUrls: ['./user-profil.component.css'],
  standalone:true,
  imports:[
     CommonModule,
        FormsModule,
        NgbModule,
        NgxPaginationModule,
        LoadingComponent,
        SampleSearchPipe,
        NgSelectModule
  ]
})
export class UserProfilComponent implements OnInit {
  loading=false
  user:any;
  users:any[]=[];

  constructor(
    
    private userService:UserService,
    private authService:AuthService,
    private lsService:LocalStorageService,
    private router: Router,
    private modalService: NgbModal,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    this.user=this.lsService.get(GlobalName.userName)

    this.getUsers()
  }


  getUsers(){
  this.userService.getAll().subscribe((res:any)=>{
      this.users=res.data 

      this.modalService.dismissAll()
    },
    (err:any)=>{
      AppErrorShow.showError("Gestion des utilisateurs",err)

    })
  }


  
  update(value:any){

    this.loading=true
    this.authService.update(value).subscribe((res:any)=>{
      this.loading=false
      this.lsService.set(GlobalName.userName,res.data);
      this.user=res.data
      this.toastr.success('Sauvegarde des informations du compte', 'Mon compte');
    },
    (err:any)=>{
      this.loading=false
      this.toastr.success('Sauvegarde des informations échouée', 'Mon compte');

    });
  }

  changePassword(value:any){
    this.loading=true
    this.authService.changePassword(value).subscribe((res:any)=>{
      this.loading=false
      this.toastr.success('Changement de mot de passe du compte', 'Mon compte');
      this.logout()
    },
    (err:any)=>{
      this.loading=false
      this.toastr.error('Changement de mot de passe échouée', 'Mon compte');

    });
  }
  upWallet(value:any){
    this.loading=true
    this.authService.upWallet(value).subscribe((res:any)=>{
      this.loading=false
      this.toastr.success('Compte crédité', 'Mon compte');
    },
    (err:any)=>{
      this.loading=false
      this.toastr.error('Compte non crédité', 'Mon compte');

    });
  }

  logout(){
    this.authService.logout().subscribe((res:any)=>{
      this.lsService.remove(GlobalName.tokenName)
      this.lsService.remove(GlobalName.refreshTokenName)
      this.lsService.remove(GlobalName.expireIn)
      this.router.navigate(['/login'])
      this.toastr.success('Déconnexion réussie', 'Connexion');
    }),
    ((err:any)=>{
      console.log(err)
      this.toastr.success('Déconnexion échouée', 'Connexion');

    });
  }
}
